var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewIconOffline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.38404,
    cy: 4.38404,
    r: 4.38404,
    fill: "#FE8FB6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29186 2.85848C5.64992 2.85848 6.59664 3.71945 7.00854 4.18366C6.60807 4.70876 5.66135 5.71694 4.29186 5.71694C3.02842 5.71694 2.0251 4.70619 1.58261 4.17137C2.00938 3.70058 2.95953 2.85848 4.29186 2.85848ZM4.29186 2.28679C2.12829 2.28679 0.857422 4.15936 0.857422 4.15936C0.857422 4.15936 2.23949 6.28863 4.29186 6.28863C6.50231 6.28863 7.71773 4.15936 7.71773 4.15936C7.71773 4.15936 6.49116 2.28679 4.29186 2.28679ZM4.28757 3.14432C3.65614 3.14432 3.14419 3.65656 3.14419 4.28771C3.14419 4.91914 3.65614 5.43109 4.28757 5.43109C4.91901 5.43109 5.43096 4.91914 5.43096 4.28771C5.43096 3.65656 4.91901 3.14432 4.28757 3.14432Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29297 2.00002L2.00003 6.29292",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIconOffline);
export default __webpack_public_path__ + "static/media/ViewIconOffline.7228685422ecef0ae5472a05a2f4f239.svg";
export { ForwardRef as ReactComponent };